(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flip-cards"] && !Shopify.designMode) return;
  try {
    
  (function initFlipCards() {
    const isTouchOnly = !window.matchMedia('(hover: hover)').matches;

    if (!isTouchOnly) return;

    document.querySelectorAll('.flip-card').forEach(function (card) {
      card.addEventListener('click', function () {
        card.classList.toggle('is-flipped');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.media-with-accordion accordion-disclosure').forEach((accordion) => {
    accordion.summaryElement.addEventListener(
      'click',
      () => {
        const container = accordion.parentElement;

        container.querySelectorAll('accordion-disclosure').forEach((other) => {
          if (other !== accordion) {
            other.close();
          }
        });
      },
      true
    ); // capture: true
  });

  } catch(e) { console.error(e); }
})();
})();
